import type { FaireProductEntity } from "../../entity_types/product";

export const brooklyn_cookie_1: FaireProductEntity = {
  token: "brooklyn-cookie-1",
  type: "product",
  name: "Artisan Chocolate Chip Cookies",
  brandName: "Brooklyn Cookie Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/245d98016865b8aec5fec7bfb250bc895d0504ecc6ffcf92f49696f167a07840.webp",
  priceDollars: 12,
  msrpDollars: 20,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
